
export const BANK_OPTIONS = [
    "Banco do Brasil",
    "Bradesco",
    "Itaú",
    "Santander",
    "Caixa Econômica Federal",
    "Nubank",
    "Inter",
    "C6 Bank",
    "BTG Pactual",
    "XP Investimentos",
    "Outro"
];

export const ACCOUNT_TYPES = [
    { value: "corrente", label: "Conta Corrente" },
    { value: "poupanca", label: "Poupança" },
    { value: "investimento", label: "Investimento" },
    { value: "caixa", label: "Caixa Interno (Dinheiro)" }
];
